var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.786792 14.1514C0.868692 14.2333 0.976212 14.274 1.08373 14.274C1.19125 14.274 1.29877 14.2329 1.38109 14.151L7.38373 8.1412L13.3864 14.151C13.4683 14.2333 13.5758 14.274 13.6837 14.274C13.7912 14.274 13.8988 14.2329 13.9807 14.1514C14.1449 13.9876 14.1449 13.7217 13.9811 13.5575L7.98433 7.55404L13.9807 1.55098C14.1445 1.38676 14.1445 1.1209 13.9802 0.957097C13.8156 0.792877 13.5502 0.792877 13.3864 0.957517L7.38331 6.9673L1.38067 0.957517C1.21645 0.793297 0.950592 0.793297 0.786792 0.957097C0.622572 1.1209 0.622572 1.38676 0.786372 1.55098L6.78229 7.55404L0.786372 13.5575C0.622572 13.7213 0.622572 13.9876 0.786792 14.1514Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/closeBtn.a89f1043d47dc7ec86b15a3f0a72b9cb.svg";
export { ForwardRef as ReactComponent };